export default __webpack_public_path__ + "8a28e149ff2a4c4de6a6c086402c5097.png";